import { useMemo } from "react";
import type { EnumTradingPlatform } from "@/api/cashier";
import { getAssetUrl } from "@/utils/helpers";

const PLATFORM_ICON_FOLDER = "icons/platforms";

export const usePlatformIcon = (tradingPlatform: EnumTradingPlatform) => {
  return useMemo(() => {
    switch (tradingPlatform) {
      case "cTrader":
        return getAssetUrl("ctrader.png", PLATFORM_ICON_FOLDER);
      case "MT4":
        return getAssetUrl("mt4.png", PLATFORM_ICON_FOLDER);
      case "MT5":
        return getAssetUrl("mt5.svg", PLATFORM_ICON_FOLDER);
      case "TradingView":
        return getAssetUrl("tradingview.png", PLATFORM_ICON_FOLDER);
      case "Pepperstone":
        return getAssetUrl("pepperstone.svg", PLATFORM_ICON_FOLDER);
      default:
        return getAssetUrl("pepperstone.svg", PLATFORM_ICON_FOLDER);
    }
  }, [tradingPlatform]);
};
